module.exports = ".input-group > button, .input-group > label {\n  margin: 0 0.2rem; }\n\n.input-group > label {\n  border-radius: 0.6rem; }\n\ntd.key-column {\n  width: 50%; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/settings-translations/settings-translations.component.scss
// module id = ./src/app/pages/settings-translations/settings-translations.component.scss
// module chunks = main